import React from 'react'
import { connect } from 'react-redux'
import ChoosePrintType from '../present/ChoosePrintType.jsx';
import toJS from '../../../containers/general/toJS.js';
import { CLI_MULTICINEMA_MODE } from '../../../constants/state.js';
import getData from '../../../functions/getData.js';
import chooseCinemasActive from '../functions/chooseCinemasActive.js';


const mapStateToProps = state => ({
    webToPrintRoutes: state.getIn(['wpServerData', 'data', 'data', 'webtoprint']),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
})

const ChoosePrintTypeContainer = ({
    webToPrintRoutes, 
    multicinemaMode,
    match,
    goBackPath,
    altGoBackPath
}) => {
    let usedWebToPrintRoutes = []

    const closePagePath = chooseCinemasActive(multicinemaMode) ? altGoBackPath : goBackPath

    if(webToPrintRoutes) {
        _.keys(webToPrintRoutes).map((route) => {
            if((webToPrintRoutes[route] === 'true' || webToPrintRoutes[route] === true ) && route != 'newsletter') {
                usedWebToPrintRoutes.push(route)
            }
        })
    }

    return (
        <ChoosePrintType
            usedWebToPrintRoutes={usedWebToPrintRoutes}
            basicUrl={match.url}
            closePagePath={closePagePath}
        />
    )
}

export default connect(mapStateToProps)(toJS(ChoosePrintTypeContainer))